import React, { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";

import { fetchSession } from "api/webservice/sessions";
import { Session } from "types";
import Room from "./Room";
import { AssessmentProvider } from "context/session/AssessmentProvider";
import { GameLiftStreamsProvider } from "context/session/GameLiftStreamsProvider";

interface Props {
  sessionId: string;
}

const SessionCall: React.FC<RouteComponentProps<Props>> = ({
  match
}: RouteComponentProps<Props>) => {
  const { sessionId } = match.params;
  const [session, setSession] = useState<Session>();

  const handleFetchSession = () => {
    fetchSession({ id: sessionId }).then(session => setSession(session));
  };

  useEffect(() => {
    handleFetchSession();
  }, [setSession]);

  if (!session) return null;

  return (
    <GameLiftStreamsProvider sessionId={session.id}>
      <AssessmentProvider session={session}>
        <Room session={session} />
      </AssessmentProvider>
    </GameLiftStreamsProvider>
  );
};

export default SessionCall;
